import { Mic, MicOff } from "lucide-react";
import { toast } from "sonner";
import { useDictation, isDictationSupported } from "@/hooks/useDictation";

export const MicButton = ({ value, onChange, testId, accent = "#dc2626" }) => {
  const { listening, start, stop } = useDictation(onChange);

  const toggle = () => {
    if (!isDictationSupported()) {
      toast.error("La dictée n'est pas prise en charge par ce navigateur. Essaie avec Chrome.");
      return;
    }
    if (listening) {
      stop();
    } else {
      const ok = start(value);
      if (ok) toast.info("🎙️ Parle, je t'écoute...");
    }
  };

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={toggle}
      title={listening ? "Arrêter la dictée" : "Dicter à la voix"}
      className={`flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold transition-all ${
        listening
          ? "border-red-500 bg-red-500 text-white shadow-md"
          : "border-[#e0d8c6] bg-white text-slate-600 hover:border-red-400 hover:text-red-600"
      }`}
    >
      {listening ? (
        <>
          <span className="relative flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white opacity-75" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-white" />
          </span>
          <MicOff size={14} />
          Stop
        </>
      ) : (
        <>
          <Mic size={14} style={{ color: accent }} />
          Dicter
        </>
      )}
    </button>
  );
};
